import { PageHeader } from '@/components/PageHeader';
import { ProgramaTVSection } from '@/components/ProgramaTVSection';

/**
 * Página standalone "Programa TV/YouTube" (também disponível como aba em Entregas).
 */
export function EpisodiosMB() {
  return (
    <div>
      <PageHeader title="Programa TV/YouTube" />
      <div className="px-6 py-4">
        <ProgramaTVSection />
      </div>
    </div>
  );
}
